import { ChainId } from '@pancakeswap/chains'

/**
 * V1 will be deprecated but is still used to claim old rounds
 */
export const STATS_SUBGRAPH_CLIENT = 'https://subgraphs.pdex.vision/subgraphs/name/stats'
export const BLOCKS_CLIENT_PULSE = 'https://subgraphs.pdex.vision/subgraphs/name/blocks'
export const V2_SUBGRAPH_CLIENT = 'https://subgraphs.pdex.vision/subgraphs/name/exchange-pulsechain'
export const V3_SUBGRAPH_CLIENT = 'https://subgraphs.pdex.vision/subgraphs/name/exchange-v3'
export const STABLESWAP_SUBGRAPH_CLIENT = 'https://subgraphs.pdex.vision/subgraphs/name/exchange-stableswap'
export const DCA_ORDERS_CLIENT_PULSECHAIN = 'https://subgraphs.pdex.vision/subgraphs/name/dca2-pulsechain'
export const ORDERS_CLIENT_PULSECHAIN = 'https://subgraphs.pdex.vision/subgraphs/name/orders-pulsechain'
